import React from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Reveal, Overline } from "./primitives";
import { LIFESTYLE_WORDS, IMAGES } from "./content";

const EASE = [0.16, 1, 0.3, 1];

export default function Lifestyle() {
  return (
    <section data-testid="lifestyle-section" className="relative overflow-hidden bg-charcoal py-28 text-warm md:py-40">
      <div className="mx-auto mb-16 max-w-[1600px] px-6 md:mb-24 md:px-12">
        <Reveal className="max-w-[26ch]">
          <Overline className="text-champagne">Imagine Living Here</Overline>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] sm:text-6xl lg:text-7xl">
            We don&apos;t sell square footage. We compose a way of living.
          </h2>
        </Reveal>
      </div>

      {/* Slow editorial marquee */}
      <div className="marquee-mask border-y border-warm/10 py-8">
        <Marquee speed={38} gradient={false} autoFill>
          {LIFESTYLE_WORDS.map((w, i) => (
            <span key={i} className="mx-8 flex items-center gap-8 font-serif text-4xl italic text-warm/85 md:text-6xl">
              {w}
              <span className="h-2 w-2 rounded-full bg-copper" />
            </span>
          ))}
        </Marquee>
      </div>

      {/* Lifestyle image strip */}
      <div className="mx-auto mt-20 grid max-w-[1600px] grid-cols-2 gap-3 px-6 md:mt-28 md:grid-cols-5 md:gap-4 md:px-12">
        {IMAGES.lifestyle.map((src, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1, ease: EASE, delay: i * 0.08 }}
            className={`clip-frame relative overflow-hidden ${
              i % 3 === 0 ? "aspect-[3/4]" : "aspect-[3/4] md:mt-12"
            }`}
          >
            <img src={src} alt="Luxury villa lifestyle" loading="lazy" className="h-full w-full object-cover" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
